import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './content-card-item.component.scss';
var ContentCardItem = /** @class */ (function (_super) {
    tslib_1.__extends(ContentCardItem, _super);
    function ContentCardItem(element) {
        return _super.call(this, element) || this;
    }
    ContentCardItem.prototype.init = function () { };
    ContentCardItem.prototype.bindEvents = function () { };
    return ContentCardItem;
}(Base));
export { ContentCardItem };



//////////////////
// WEBPACK FOOTER
// ./components/content-card-item/content-card-item.component.ts
// module id = 219
// module chunks = 0